var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Autoupdate Status ")]),
      _c(
        "gg-card-text",
        [
          _c("v-data-table", {
            attrs: {
              items: _vm.items,
              loading: _vm.loadingInfo || _vm.loadingInst,
              headers: _vm.headers
            },
            scopedSlots: _vm._u([
              {
                key: "item.softurl",
                fn: function fn(_ref) {
                  var item = _ref.item
                  return [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: item.softurl,
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(item.softurl))]
                    )
                  ]
                }
              },
              {
                key: "item.status",
                fn: function fn(_ref2) {
                  var item = _ref2.item
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          item.needsUpdate ? "Out of Date" : "Up to Date"
                        ) +
                        " "
                    )
                  ]
                }
              },
              {
                key: "item.actions",
                fn: function fn(_ref3) {
                  var item = _ref3.item
                  return [
                    item.needsUpdate
                      ? _c(
                          "gg-btn",
                          {
                            on: {
                              click: function click($event) {
                                return _vm.openModal(item)
                              }
                            }
                          },
                          [_vm._v("Update")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("update-modal", {
            attrs: {
              opened: _vm.modal,
              installation: _vm.selectedInst
            },
            on: {
              close: _vm.closeModal,
              updated: _vm.fetchInstallations
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }